export default __webpack_public_path__ + "static/media/Flag_of_Nigeria.effec442.svg";